import { Component, OnInit, Input } from '@angular/core';
import { FileTransferPayload } from 'src/app/models/FileTransferPayload';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/users-module/services/user.service';
import { ClientLocation } from 'src/app/clients-module/models/clientLocation';
import { PropertyService } from 'src/app/property-module/services/property.service';

@Component({
  selector: 'app-users-upload',
  templateUrl: './users-upload.component.html',
  styleUrls: ['./users-upload.component.less']
})
export class UsersUploadComponent implements OnInit {

  @Input() 
  public clientId : number;

  public showUploadUserPane : boolean = false;
  public fileLoaded : boolean;
  public userImportErrorMessages : string[] = [];
  public fileTransfer : FileTransferPayload = new FileTransferPayload();
  public assignAllPropertiesToImport : boolean = false;
  public propToAssign : ClientLocation;


  constructor(public auth : AuthService, public toast : ToastrService, public users : UserService, public props : PropertyService) { }

  ngOnInit() {
    this.props.FetchPropertiesForClient(this.clientId);
  }

  public showUploadUsersPane() {
    this.showUploadUserPane = !this.showUploadUserPane;
  }

  public handleFileUpload(event : any) {
    if(event.target.files && event.target.files[0]) {
      this.userImportErrorMessages = [];
      let reader = new FileReader();
      this.fileLoaded = false;

      //if the file is not a csv, pop a warning
      if(event.target.files[0].name.split('.').pop().toLowerCase() != 'csv') this.toast.error('File is not csv.');
      else {
        reader.readAsDataURL(event.target.files[0]);
  
        reader.onload = (event) => {
          this.fileTransfer.base64FileString = (<FileReader>event.currentTarget).result.toString();
          this.fileTransfer.clientId = this.clientId;
          this.fileTransfer.userId = this.auth.loggedInUser.id;
          this.fileLoaded = true;
        } 
      }
    }
  }

  public uploadFile() : void {
    this.users.UploadUsersCsv(this.fileTransfer).subscribe((res : string[] )=> {
      this.userImportErrorMessages = res;
      if(this.userImportErrorMessages.length > 0) this.toast.warning('Some users failed to import.', '', { closeButton: true, disableTimeOut: true })
      else this.toast.success('Users successfully imported!', '');
    },
    error => {
      this.toast.error('Error uploading selected file.')
    })
  }

  assignProps(prop : any) {
    this.fileTransfer.locations = [];
    if(this.assignAllPropertiesToImport) {
      this.propToAssign = undefined;
      this.props.activeProperties.forEach(r => {
        this.fileTransfer.locations.push(r);
      })
    }
    else {
      this.fileTransfer.locations.push(prop);
    }
    
  }

}
